package com.zi.support.shared

/**
 * More > Templates on web, Android and iOS: whether a report's preview uses live SupportApp data or the
 * sample a company's server would replace. Reports are listed under their company (reportTemplates/{company}).
 */
object ReportTemplates {
    /** The ticket reports are answered from SupportApp's own Firestore; every other report previews with sample data. */
    fun usesLiveData(reportId: String): Boolean = reportId.startsWith("tickets-")

    fun dataLabel(reportId: String): String = if (usesLiveData(reportId)) "Live data" else "Sample data"
}
